import { CookieKey, MasterTranslation } from '@/constants';
import { useAuth, useGlobalState } from '@/hooks';
import { useRecaptchaContext } from '@/modules/pmt/context';
import type { TrackingInputRef } from '@/modules/pmt/interfaces';
import Cookies from 'js-cookie';
import { type FC, type SyntheticEvent, useRef, useState } from 'react';
import { ReCaptchaV3Action } from '../../constants';
import { AddIcon, AddParcelsText, SubmitButton } from './TrackingWidget.styles';
import { TrackingInput } from './components/TrackingInput';

type TrackingWidgetProps = {
  handleSubmit: (trackingIds: string[]) => void;
  isDisabled?: boolean;
};

export const TrackingWidget: FC<TrackingWidgetProps> = ({ handleSubmit, isDisabled = false }) => {
  const trackingInputRef = useRef<TrackingInputRef>(null);
  const [inputText, setInputText] = useState<string>('');
  const [trackingIds, setTrackingIds] = useState<string[]>([]);
  const { t } = useGlobalState();
  const { checkWithReCaptchaV3 } = useRecaptchaContext();
  const { authGuest } = useAuth();

  const onSubmit = async (event: SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault();

    const finalTrackingIds = trackingInputRef.current?.processInput() || trackingIds;
    if (!finalTrackingIds.length) return;

    const accessToken = Cookies.get(CookieKey.AccessToken);

    if (!accessToken) {
      await authGuest();
    }

    await checkWithReCaptchaV3({
      action: ReCaptchaV3Action.SubmitTrackingWidget,
      callback: () => {
        handleSubmit(finalTrackingIds);
        setTrackingIds([]);
      },
    });
  };

  return (
    <form onSubmit={onSubmit}>
      <TrackingInput
        ref={trackingInputRef}
        chips={trackingIds}
        setChips={setTrackingIds}
        maxChip={5}
        isDisabled={isDisabled}
        onChange={setInputText}
      />
      <SubmitButton disabled={isDisabled && !inputText && !trackingIds.length}>
        <AddIcon src='/images/icons/add.svg' alt='add icon' aria-hidden={true} />
        <AddParcelsText>{t(MasterTranslation.AddParcels)}</AddParcelsText>
      </SubmitButton>
    </form>
  );
};
